import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Modal from './../index'
import './form.css'

class ReplyProductDetail extends Component {
  state = {
    name: ''
  }
  componentDidMount () {
    this.setState({ name: this.props.unit.suggested_name !== null ? this.props.unit.suggested_name : this.props.unit.name })
  }
  handleChange = (event) => {
    this.setState({ name: event.target.value })
  }
  render () {
    const { handleCloseModal, changeNameUnit, unit } = this.props
    return (
      <div className='modal__container'>
        <Modal.Header title='Editar Escola' handleCloseModal={handleCloseModal} />
        <Modal.Body>
          <form className='pure-form pure-form-stacked'>
            <fieldset>
              <div className='pure-g'>
                <div className='pure-u-1 pure-u-md-1-3'>
                  <label htmlFor='first-name'>Escola</label>
                  <input id='first-name' className='pure-u-23-24' type='text' onChange={this.handleChange} value={this.state.name} />
                </div>
                <div className='pure-u-1 pure-u-md-1-3'>
                  <label htmlFor='last-name'>Endereço</label>
                  <input id='last-name' className='pure-u-23-24' type='text' value={unit.complement.name} disabled />
                </div>
                <div className='pure-u-1 pure-u-md-1-3'>
                  <label htmlFor='email'>Bairro</label>
                  <input id='email' className='pure-u-23-24' type='text' value={unit.complement.neighborhood} disabled />
                </div>
                <div className='pure-u-1 pure-u-md-1-3'>
                  <label htmlFor='city'>Cidade</label>
                  <input id='city' className='pure-u-23-24' type='text' value={unit.city.name} disabled />
                </div>
                <div className='pure-u-1 pure-u-md-1-3'>
                  <label htmlFor='state'>Estado</label>
                  <input id='city' className='pure-u-23-24' type='text' value={unit.state.name} disabled />
                </div>
              </div>
            </fieldset>
          </form>
          <div style={{
            width: '100%',
            textAlign: 'right',
            paddingRight: '10px',
            paddingBottom: '10px'
          }}>
            <button onClick={() => changeNameUnit(this.state.name)} className='button is-success button--send'>Confirmar</button>
          </div>
        </Modal.Body>
      </div>
    )
  }
}

ReplyProductDetail.propTypes = {
  handleCloseModal: PropTypes.func.isRequired
}

export default ReplyProductDetail



// WEBPACK FOOTER //
// ./src/components/Modal/ChangedUnit/index.js